export const planSelectionViewPlan = () => ({
  type: 'Onboarding View Plan',
});

export const userViewsCrunchingNumbersPage = () => ({
  type: 'User views Crunching Numbers page',
});

export const onboardingInitiated = (flowType = 'Onboarding') => ({
  type: `Multistep ${flowType} Initiated`,
  data: {
    version: '3.0',
  },
});

export const getCustomerEmail = (position, customer) => {
  if (position !== 0) {
    return {
      email: customer?.email,
    };
  }
};

export const onboardingSubmitted = (
  position,
  question,
  customer,
  response,
  flowType = 'Onboarding',
) => ({
  type: `${flowType} Response Submitted`,
  data: {
    position,
    question,
    customer_info: getCustomerEmail(position, customer),
    response,
  },
});

export const onboardingBackButtonClicked = (
  start_position,
  flowType = 'Onboarding',
) => ({
  type: `${flowType} Back Button Clicked`,
  data: {
    start_position,
  },
});

export const onboardingQuestionSubmitted = position => ({
  type: 'Onboarding Response Submitted',
  data: {
    position,
  },
});

export const onboardingCTAClicked = position => ({
  type: 'Onboarding Quiz CTA',
  data: {
    position,
  },
});

export const onboardingBackArrowClicked = (page, customer) => ({
  type: 'User Leaves Step',
  data: {
    page,
    email: customer?.email,
  },
});

export const userViewsOnboardingInterstitial = previous_question => ({
  type: 'User views Onboarding Interstitial',
  data: {
    previous_question,
  },
});

export const userContinuesFromInterstitial = previous_question => ({
  type: 'User continues from Interstitial',
  data: {
    previous_question,
  },
});

export const userViewsOnboardingIntro = () => ({
  type: 'User views Onboarding Intro',
  data: {},
});

export const userContinuesFromIntro = () => ({
  type: 'User continues from Intro',
  data: {},
});
